import { Collection } from 'types/collection'
import { useFilterCategory } from './useFilterCategory'
import { useFiltersToggle } from '../CollectionFilter/useFiltersToggle'
import { getProductCategory } from '@helpers/products'
import { getValueFromObject } from '@helpers/utils'

type ProductTypeByCatetory = { [category: string]: Collection[] }

function getProductTypesByCategory(collections: Collection[] = []) {
  const productTypesByCategory: ProductTypeByCatetory = {}
  collections.forEach(collection => {
    const productCategory = getProductCategory(
      getValueFromObject(collection, 'items[0].options', []),
      collection.product_type
    )

    if (productCategory) {
      productTypesByCategory[productCategory] = [
        ...(productTypesByCategory[productCategory] || []),
        collection
      ]
    }
  })

  return productTypesByCategory
}

function getCollectionsByFiltersCategory(
  filterCategory: string,
  productTypesByCategory: ProductTypeByCatetory = {}
) {
  return {
    collectionsByFiltersCategory: productTypesByCategory[filterCategory] || [],
    filtersCategories: Object.keys(productTypesByCategory)
  }
}

export function useFilterContext({
  metaFilters,
  collections
}: {
  metaFilters?: {
    multi: boolean
    show: boolean
  }
  collections: Collection[]
}) {
  const { isFiltersOpen, closeFilters, openFilters } = useFiltersToggle()
  const [filterCategory, setFilterCategory] = useFilterCategory(
    metaFilters ? metaFilters.multi : false
  )

  const productTypesByCategory = getProductTypesByCategory(collections)
  const { collectionsByFiltersCategory, filtersCategories } =
    getCollectionsByFiltersCategory(filterCategory, productTypesByCategory)

  return {
    filterCategory,
    setFilterCategory,
    collectionsByFiltersCategory,
    filtersCategories,
    isFiltersOpen,
    closeFilters,
    openFilters,
    showFilters: metaFilters?.show
  }
}
